function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (character) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
  })[character]!);
}

export function repairAtelierResetButton(
  orderId: string,
  orderName: string,
  pending: boolean,
  busy: boolean,
): string {
  return `<button type="button" class="repair-atelier-reset"
    data-reset-repair-atelier-order="${escapeHtml(orderId)}"
    aria-label="${escapeHtml(orderName)}の依頼工房の選択をリセット"
    title="未保存の選択を取り消します。保存済みの工房・依頼日は変更しません。"
    ${!pending || busy ? "disabled" : ""}>リセット</button>`;
}

export function resetRepairAtelierSelection(
  selections: Map<string, string>,
  orderId: string,
  busy: boolean,
): boolean {
  // Dropping the draft restores the saved value (or leaves all radios unchecked
  // when no atelier was saved). This must never invoke a record-reset API.
  return !busy && selections.delete(orderId);
}
